
import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IAddDefinitionChangeParamRequest {
  roleLevel: number;  
  processGroup: string;
  processType: string;
}

async function addDefinitionChangeParam(data: IAddDefinitionChangeParamRequest): Promise<any> {
  try {
    return (await axiosInstance.post("/DefinitionChangeParam/Add", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useAddDefinitionChangeParam() {
  return useMutation<any, Error, IAddDefinitionChangeParamRequest>((variables) =>
    addDefinitionChangeParam(variables)
  );
}
